/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Trend_SameInputs */

const en_us2_profile_editors_pain_trend_same = /** @type {(inputs: Profile_Editors_Pain_Trend_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same`)
};

const pt_br2_profile_editors_pain_trend_same = /** @type {(inputs: Profile_Editors_Pain_Trend_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igual`)
};

const es_419_profile_editors_pain_trend_same = /** @type {(inputs: Profile_Editors_Pain_Trend_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igual`)
};

const pt_pt2_profile_editors_pain_trend_same = /** @type {(inputs: Profile_Editors_Pain_Trend_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igual`)
};

const fr_fr2_profile_editors_pain_trend_same = /** @type {(inputs: Profile_Editors_Pain_Trend_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pareil`)
};

const de_de2_profile_editors_pain_trend_same = /** @type {(inputs: Profile_Editors_Pain_Trend_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleich`)
};

const it_it2_profile_editors_pain_trend_same = /** @type {(inputs: Profile_Editors_Pain_Trend_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uguale`)
};

/**
* | output |
* | --- |
* | "The same" |
*
* @param {Profile_Editors_Pain_Trend_SameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_trend_same = /** @type {((inputs?: Profile_Editors_Pain_Trend_SameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Trend_SameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_trend_same(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_trend_same(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_trend_same(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_trend_same(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_trend_same(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_trend_same(inputs)
	return en_us2_profile_editors_pain_trend_same(inputs)
});
export { profile_editors_pain_trend_same as "profile-editors.pain_trend_same" }